import React, { Component } from 'react'
import Axios from 'axios'
import UserValidation from './UserValidation'
import Form from './Form'
import {Select, MenuItem, Menu} from '@material-ui/core';
import {send} from '../helper/requests'

var i=0;


class Support extends Component {
    constructor(props){
        super();
        this.state ={
            questions:[],
            answers:[],
            selectedQuestion:'',
            questionHead:'',
            buttonsState:false,
            showButtons:'showButtons',
            hideButtons:'hideButtons',
            validReq:0,
            loadScreen:'qandA'
        }
    }
    
    componentDidMount = async() => {
        try{
            //const response = await Axios.get(baseURL + '/api/v1/website/support/questions?includeAnswers=false');
            const response = await send({
                url:'/api/v1/website/support/questions?includeAnswers=false',
                method:'GET',
            })
            console.log(response.data)
        this.setState({
            questions:response.data
        })
        console.log(this.state.questions)
    }
    catch(error){
        console.log(error);
    }
    }
   
    getAnswers = async(e) => {
        console.log(e.target.value)
        

        

        if(e.target.value !== "") {
            this.setState({
                selectedQuestion:e.target.value,
                //validReq:this.state.questions[e.target.value-1].validReq,
                questionHead:this.state.questions.question
            })
            
            try{
                const answers = await send({
                    url:'/api/v1/website/support/questions/'+e.target.value+'/answers',
                    method:'GET',
                })
                //console.log(answers.data.records);
                this.setState({
                    answers:answers.data,
                    buttonsState:true
                })
                console.log(this.state.answers)

            }
            catch(error){
                console.log(error);
                alert('cevab veremedi');
            }
        }
    }
    askQuestion () {
            this.setState({
                loadScreen:'kassaForm'
            })
    } 
    prevStep = () => {
        const {loadScreen} = this.state
        this.setState({
            loadScreen: 'qandA'
        })
    }
    nextStep = () => {
        const {loadScreen} = this.state
        this.setState({
            loadScreen: 'kassaForm'
        })
    }
    render() {
        return(
            <Form
                prevStep={this.prevStep}
            />
        )
    }
}
export default Support